export const GET_PRODUCT_BY_HANDLE = `
  query getProduct($handle:String){
    product(handle:$handle){
        availableForSale
        featuredImage {
        height
        src
        url
        width
        originalSrc
        id
        altText
        }
        handle
        id
        totalInventory
        compareAtPriceRange {
          maxVariantPrice {
              amount
              currencyCode
          }
        }
        priceRange {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        collections(first: 10) {
          nodes {
            id
          }
        }
        onlineStoreUrl
        productType
        publishedAt
        requiresSellingPlan
        tags
        title
        updatedAt
        vendor
        createdAt
        description
        descriptionHtml
        variants(first: 200) {
      edges {
        node {
          availableForSale
          title
          unitPrice {
            amount
            currencyCode
          }
          quantityAvailable
          requiresShipping
          id
          currentlyNotInStock
          barcode
          image {
            height
            src
            url
            width
            id
            originalSrc
            altText
          }
          priceV2 {
            amount
            currencyCode
          }
          selectedOptions {
            name
            value
          }
          sku
          product {
            id
            title
            productType
          }
          metafield(namespace: "hk-app", key: "session-editor-price-change") {
            namespace
            key
            value
            type
          }
          xLeftAutomation: metafield(namespace: "hk-app", key: "x-left-automation") {
            value
          }
          postcodeDiscountAdjustment: metafield(namespace: "hk-app", key: "postcode-discount-adjustment") {
            value
          }
        }
      }
    }
    }
  }
`;

// Shop-level metafield read, e.g. the day-type intervals mirrored by the HK admin.
export const GET_SHOP_METAFIELD = `
  query ($namespace: String!, $key: String!) {
    shop {
      metafield(namespace: $namespace, key: $key) {
        value
      }
    }
  }
`;

export const GET_PRODUCTS_BY_MONTH = `
  query($query: String) {
    products(first: 250, query: $query) {
      nodes {
        id
        tags
        vendor
        title
        handle
        variants(first: 150) {
          nodes {
            title
            availableForSale
            quantityAvailable
            selectedOptions {
              name
              value
            }
            priceV2 {
              amount
              currencyCode
            }
            compareAtPriceV2 {
              amount
              currencyCode
            }
            metafield(namespace: "hk-app", key: "session-editor-price-change") {
              namespace
              key
              value
              type
            }
            xLeftAutomation: metafield(namespace: "hk-app", key: "x-left-automation") {
              value
            }
            postcodeDiscountAdjustment: metafield(namespace: "hk-app", key: "postcode-discount-adjustment") {
              value
            }
          }
        }
      }
    }
  }
`;

export const CREATE_CART = `
  mutation cartCreate {
    cartCreate {
      cart {
        checkoutUrl
        id
      }
    }
  }
`;

export const ADD_TO_CART_LINES = `
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        checkoutUrl
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              attributes {
                key
                value
              }
              sellingPlanAllocation {
                sellingPlan {
                  id
                  name
                }
              }
              merchandise {
                ... on ProductVariant {
                  availableForSale
                  title
                  unitPrice {
                    amount
                    currencyCode
                  }
                  quantityAvailable
                  requiresShipping
                  id
                  currentlyNotInStock
                  barcode
                  image {
                    height
                    src
                    url
                    width
                    id
                    originalSrc
                    altText
                  }
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  sku
                  product {
                    id
                    title
                    productType
                  }
                }
              }
            }
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const GET_CART_LINES = `
  query GetCartLines($id: ID!) {
    cart(id: $id) {
      id
      createdAt
      updatedAt
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      lines(first: 100) {
        edges {
          node {
            discountAllocations {
              discountedAmount {
                amount
              }
              ...Discounts
            }
            id
            quantity
            attributes {
              key
              value
            }
            sellingPlanAllocation {
              sellingPlan {
                id
                name
              }
            }
            merchandise {
              ... on ProductVariant {
                availableForSale
                title
                unitPrice {
                  amount
                  currencyCode
                }
                quantityAvailable
                requiresShipping
                id
                currentlyNotInStock
                barcode
                image {
                  height
                  src
                  url
                  width
                  id
                  originalSrc
                  altText
                }
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                sku
                product {
                  id
                  title
                  productType
                }
              }
            }
          }
        }
      }
    }
  }

  fragment Discounts on CartDiscountAllocation {
    ... on CartCodeDiscountAllocation {
      code
    }
    ... on CartAutomaticDiscountAllocation {
      title
    }
    ... on CartCustomDiscountAllocation {
      title
    }
  }
`;

export const UPDATE_CART_LINES = `
  mutation UpdateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(
      cartId: $cartId
      lines: $lines
    ) {
      cart {
        id
        lines(first: 100) {
          edges {
            node {
              discountAllocations {
                discountedAmount {
                  amount
                }
                ...Discounts
              }
              id
              quantity
              attributes {
                key
                value
              }
              sellingPlanAllocation {
                sellingPlan {
                  id
                  name
                }
              }
              merchandise {
                ... on ProductVariant {
                  availableForSale
                  title
                  unitPrice {
                    amount
                    currencyCode
                  }
                  product {
                    id
                    title
                    featuredImage {
                      id
                      url
                    }
                  }
                  image {
                    height
                    src
                    url
                    width
                    id
                    originalSrc
                    altText
                  }
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  id
                }
              }
            }
          }
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }

  fragment Discounts on CartDiscountAllocation {
    ... on CartCodeDiscountAllocation {
      code
    }
    ... on CartAutomaticDiscountAllocation {
      title
    }
    ... on CartCustomDiscountAllocation {
      title
    }
  }
`;

export const GET_METAOBJECT_BY_HANDLE = `
  query ($handle: String!, $type: String!){
    metaobject(handle: {handle: $handle, type: $type}) {
      fields {
        value
        type
      }
    }
  }
`;

export const GET_IMAGE_BY_ID = `
  query ($id: ID!) {
    node(id: $id) {
      ... on MediaImage {
        image {
            url
            altText
          }
      }
    }
  }
`;
